import React from 'react'


const Services = () => {
  return (
    <div className="services">
      <h1>I am the service page</h1>
    </div>
  )
}


export default Services;